import { BuiltinInstanceMemberValue } from '../BuiltinInstanceMemberValue';
export class MapSize extends BuiltinInstanceMemberValue {
    emit(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.unwrapMap);
        sb.emitOp(node, 'ARRAYSIZE');
        sb.emitHelper(node, options, sb.helpers.wrapNumber);
    }
}

//# sourceMappingURL=size.js.map
